module.exports = __webpack_public_path__ + "img/customers_apps.121c46e1.png";